/** Misma lista que el sidebar: módulo Reportes */
export const reportesMenu = [
  { key: 'ingreso-por-dia', label: 'INGRESOS' },
  { key: 'gastos', label: 'GASTOS' },
  { key: 'popularidad', label: 'POPULARIDAD DE PRODUCTOS' },
  { key: 'descuentos-cortesias', label: 'RELACIÓN DESCUENTOS Y CORTESÍAS' },
  { key: 'cancelaciones', label: 'CANCELACIONES' },
  { key: 'relacion-ventas', label: 'RELACION DE VENTAS' },
  { key: 'ventas-por-hora', label: 'VENTAS POR HORA' },
  { key: 'productos-vendidos-por-mesero', label: 'PRODUCTOS VENDIDOS POR MESERO' },
];

/** Submenú Seguridad del sidebar (usuarios / roles) */
export const configuracionesMenu = [
  { key: 'usuarios', label: 'Usuarios' },
  { key: 'roles', label: 'Roles' },
];

/** Submenú Organizaciones del sidebar (empresas / sucursales) */
export const organizacionesMenu = [
  { key: 'empresas', label: 'Empresas' },
  { key: 'sucursales', label: 'Sucursales' },
];
